import React, {Component} from 'react';
import './style.scss';
import Arrow from './arrow';
import {trackEvent} from '../../../utils/tracking.js';
import {publish} from '../../../utils/eventBus';
import PropTypes from 'prop-types';

class Slider extends Component {

    constructor(props) {
        super(props);

        this.state = {
            slides: [],
            page: 0
        };

        this.changeSlide = this.changeSlide.bind(this);
    }

    changeSlide(e, direction) {
        e.preventDefault();
        e.stopPropagation();

        const step = (direction === 'next') ? 1 : -1,
            totalPages = this.state.slides.length;

        let currentPage = this.state.page;

        switch (currentPage + step) {
            case -1:
                currentPage = totalPages - 1;
                break;
            case totalPages:
                currentPage = 0;
                break;
            default:
                currentPage = currentPage + step;
                break;
        }

        publish('pauseInternalPlayers', {gigId: this.props.gigId});

        this.setState({
            page: currentPage
        });

        trackEvent(`carousel_arrow_${direction}`, this.props.cardType, this.props.cardSize);
        trackEvent(`carousel_arrow_${direction}`, this.props.cardType, this.props.cardSize, 'click', {gigId: this.props.gigId}, 'bigquery');
    }

    render() {
        const slideWidth = this.props.slideWidth || 230;
        this.state.slides = this.props.children; // eslint-disable-line

        const hasSlides = this.state.slides.length > 1;

        return (
            <div className="media-slider">
                {hasSlides && <Arrow direction="next" onClick={(e) => this.changeSlide(e, 'next')}/>}

                <div className="slides" style={{width: this.state.slides.length * slideWidth, transform: `translateX(-${slideWidth * this.state.page}px)`}}>
                    {this.props.children}
                </div>

                {hasSlides && <Arrow direction="prev" onClick={(e) => this.changeSlide(e, 'prev')}/>}
            </div>
        );
    }
}


Slider.propTypes = {
    gigId: PropTypes.number,
    children: PropTypes.any
};

export default Slider;



// WEBPACK FOOTER //
// ./src/shared/media/slider/index.js